<script lang="ts">
  interface Props {
    config: Record<string, unknown>;
    isNew?: boolean;
  }
  let { config = $bindable(), isNew = true }: Props = $props();
  // Webhook has no client-side config — secret + URL are server-rendered after create.
</script>

{#if isNew}
  <p class="source-help">
    After saving, you'll get a webhook URL and signing secret to use in your external service.
  </p>
{/if}

<style>
  .source-help { color: #555; padding: .75rem; background: #f8f8f8; border-radius: 4px; }
</style>
